import { useMutation } from '@apollo/client';

import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';

import { IgnoreUsageDetails, IgnoreUsageDetailsVariables } from
  '@/graphql/contracts/_generated_/ignoreUsageDetails.mutation';

import { UsageDetailDataInputType } from '@/graphql/contracts/_generated_/contracts';

import IgnoreUsageDetailsMutation from '@/graphql/contracts/ignoreUsageDetails.mutation.gql';
import GetVarBillingUsageHeaderQuery from '@/graphql/contracts/getVarBillingUsageHeader.query.gql';
import GetVarBillingUsageDetailsStatsQuery from '@/graphql/contracts/getVarBillingUsageDetailsStats.query.gql';

export default function useIgnoreUsageDetails() {
  const { fileId }: { fileId: string } = useParams();

  const [_ignoreUsageDetails, { loading }] = useMutation<IgnoreUsageDetails, IgnoreUsageDetailsVariables>(
    IgnoreUsageDetailsMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      onCompleted: () => {
        notificationService.open({
          title: 'Usage Details Ignored',
          text: 'Usage Details ignored successfully',
          type: 'success'
        });
      }
    }
  );

  const ignoreUsageDetails = async (
    usageHeaderId: string,
    usageDetails: UsageDetailDataInputType[],
    ignoreComment?: string
  ) => {
    const res = await _ignoreUsageDetails({
      variables: {
        input: { usageHeaderId, usageDetails, ignoreComment: ignoreComment || null }
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetVarBillingUsageHeaderQuery,
          variables: {
            id: fileId
          },
        },
        {
          query: GetVarBillingUsageDetailsStatsQuery,
          variables: {
            filter: {
              headerPrimaryKey: { eq: usageHeaderId }
            },
          },
        },
      ],
    });

    return res?.data?.ignoreUsageDetails ?? null;
  };

  return {
    ignoreUsageDetails,
    isLoadingIgnoreUsageDetails: loading
  } as const;
}
